import { render, staticRenderFns } from "./DryMilk.vue?vue&type=template&id=6fc6ecbc&scoped=true"
import script from "./DryMilk.vue?vue&type=script&lang=js"
export * from "./DryMilk.vue?vue&type=script&lang=js"
import style0 from "./DryMilk.vue?vue&type=style&index=0&id=6fc6ecbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6ecbc",
  null
  
)

export default component.exports